<h1 i18n="@@tac_headline">
    Terms and Conditions
</h1>

<p i18n="@@tac_intro">General Terms &amp; Conditions of Business of Stefanie Hering-Berlin GmbH (07.2013)</p>
<h2 i18n="@@tac_1-headline">1. General – scope</h2>
<p i18n="@@tac_1-1">1.1 The following Terms &amp; Conditions of Business shall apply to all contracts which are
    concluded either in or outside the offices of Stefanie Hering-Berlin GmbH (Hering Berlin) between Hering Berlin
    and its customers.
</p>
<p i18n="@@tac_1-2">1.2 These General Terms &amp; Conditions of Business shall apply exclusively. General terms and
    conditions of business issued by customers shall not be recognised, unless Hering Berlin has agreed to their
    validity in writing. These General Terms &amp; Conditions of Business shall apply even if Hering Berlin, though
    cognizant of conflicting general terms and conditions of business issued by customers, accepts without reservation
    the offer to conclude a contract.
</p>
<p i18n="@@tac_1-3">1.3. Customers in the sense of these Terms &amp; Conditions of Business shall be both traders
    and consumers.
</p>
<p i18n="@@tac_1-4">1.4. Please note, pursuant to Section 26, Paragraph 1 of the German Data Protection Act, that
    all customer-related data required to handle the contract will be recorded, stored and processed using electronic
    data processing.
</p>
<h2 i18n="@@tac_2-headline">2. Conclusion of contract – product information – delivery time</h2>
<p i18n="@@tac_2-1">2.1 A contract shall only be created upon express confirmation by Stefanie Hering - Berlin GmbH. In
    the case of contracts between Stefanie Hering-Berlin GmbH and traders this confirmation must be in writing.
</p>
<p i18n="@@tac_2-2">2.2 Hering Berlin manufactures each item individually by hand, so that slight deviations from the
    measurement pattern may occur. Technical and other deviations in shape, colour or weight compared with goods
    illustrated on the website <a href="https://b2b.hering-berlin.com">b2b.hering-berlin.com</a> or in brochures and
    advertising material are hereby reserved within the limits of what may reasonably be expected. Precise information
    on the use and care of products can be found in the Catalog of Hering Berlin.
</p>
<p i18n="@@tac_2-3">2.3 Dispatch shall usually be about 8-12 weeks following confirmation of order by Stefanie
    Hering-Berlin GmbH, in case of advance payment following receipt of the said payment for the whole amount invoiced,
    including ancillary costs and costs of carriage. In the case of special designs and large orders the delivery time
    may be longer and shall be discussed between the Contracting Parties.
</p>
<h2 i18n="@@tac_3-headline">3. Transfer of risk</h2>
<p i18n="@@tac_3-1">3.1 In the case of consumers, risk of contingent destruction and contingent deterioration of goods
    purchased, including those purchased by mail order, shall pass to the consumer upon transfer of the goods. In the
    case of traders, risk of contingent destruction and contingent deterioration of goods shall pass to the trader upon
    transfer, in the case of mail order upon delivery of the goods to the forwarder, freight carrier or other person or
    institution appointed to carry out the shipment.
</p>
<p i18n="@@tac_3-2">3.2 It shall be equivalent to transfer if the customer is in default of acceptance.
</p>
<h2 i18n="@@tac_4-headline">4. Reservation of title</h2>
<p i18n="@@tac_4-1">4.1 In relation to consumers Hering Berlin hereby reserves title to the goods until full payment of
    the purchase price. In relation to traders Hering Berlin hereby reserves title to the goods until settlement of all
    outstanding receivables due under current business relations. Should the value of the reserved goods exceed the
    secured receivable due under current business relation by 10%, Hering Berlin shall have a duty to release the said
    reserved goods upon demand by the trader.
</p>
<p i18n="@@tac_4-2">4.2 The customer must inform Hering Berlin immediately of any distraints upon the goods,
    particularly compulsory executions, and any damage thereto or destruction thereof. The same shall apply to a change
    of ownership of the goods or a change of address by the customer. The customer must compensate Hering Berlin for the
    loss incurred by any breach of this duty should he be responsible for the said breach.
</p>
<p i18n="@@tac_4-3">4.3 While reservation of title by Hering Berlin subsists, the trader shall be entitled to resell the
    goods in the course of due and proper business activity. In such case he hereby now assigns to Hering Berlin all
    receivables, up to the amount invoiced, due to him from a third party through the resale. Hering Berlin hereby
    accepts the assignment. Following assignment, the trader shall be authorised to collect the receivable. Hering
    Berlin hereby reserves the right to collect the receivable itself as soon as the trader is in arrears of
    payment.
</p>
<h2 i18n="@@tac_5-headline">5. Purchase price – payment</h2>
<p i18n="@@tac_5-1">5.1 Should Hering Berlin send goods to the customer, the latter shall pay the costs of delivery and
    carriage in addition to the stated price. The following costs of carriage shall be charged for dispatch to Germany
    and Austria if the purchaser is a consumer.

    For goods with a value of up to € 500 € 9.00
    For goods with a value of € 501 to 1,500 € 12.00
    For goods with a value of € 1,501 to 5,000 € 22.00

    Otherwise costs of carriage shall be subject to individual offer.
</p>
<p i18n="@@tac_5-2">5.2 Should the amount of the order be € 300 (net) or less, Hering Berlin shall charge a supplement
    of € 10 due to the small delivery amount.
</p>
<p i18n="@@tac_5-3">5.3 In the case of new customers who are also traders, the minimum amount of order shall be € 3,000
    and delivery shall be exclusively by advance payment.
</p>
<p i18n="@@tac_5-4">5.4 In the case of special designs, the amount invoiced must be paid prior to start of production.
</p>
<p i18n="@@tac_5-5">5.5 Payment of purchase price shall be in cash, by EC card or credit card and, as far as possible,
    by
    bank transfer. Payment by check shall not be possible. Bank charges for transfers from abroad must be paid by the
    customer.
</p>
<p i18n="@@tac_5-6">5.6 The customer hereby agrees, should advance payment not be required, to pay the purchase price
    within five working days following receipt of invoice at latest, unless another payment date is indicated on the
    invoice. Following expiry of these periods the customer shall be in arrears.
</p>
<p i18n="@@tac_5-7">5.7 In relation to a trader Hering Berlin hereby reserves the right to prove and claim damages due
    to arrears interest greater than the statutory amount, but the trader shall be free to prove a lower loss.</p>
<p i18n="@@tac_5-8">5.8 The customer shall have a right of offset only if his counterclaims have been finally confirmed
    at law or have been recognised in writing by Hering Berlin. A trader may only exercise a right of retention if his
    counterclaims are based on the same contractual relations.
</p>
<p i18n="@@tac_5-9">5.9 Should goods be ordered which the customer will collect himself, a payment on account of 50%
    must be made upon conclusion of the purchase contract and order. The remainder of the purchase price shall be
    payable upon collection of the goods.
</p>
<h2 i18n="@@tac_6-headline">6. Guarantee</h2>
<p i18n="@@tac_6-1">6.1 In the case of traders Hering Berlin shall effect its guarantee for defects to goods initially
    by repair or replacement delivery, as it may choose.
</p>
<p i18n="@@tac_6-2">6.2 Should an initial attempt at subsequently fulfilment fail, Hering Berlin shall again effect its
    guarantee for the trader either by repair or replacement delivery, as it may choose. Following failure of the second
    attempt at subsequent fulfilment, the trader shall be entitled to reduce the price or to withdraw from contract, as
    he may choose.
</p>
<p i18n="@@tac_6-3">6.3 Should a plurality of goods have been sold, a withdrawal from contract shall only be possible
    with respect to the defective part, unless the trader no longer has any interest in the defect-free parts. The
    trader must set out and prove the facts showing that he no longer has any interest in the defect-free parts.
</p>
<p i18n="@@tac_6-4">6.4 Consumers must notify Hering Berlin in writing of any obvious defects in the goods within two
    weeks following receipt. Otherwise any claim under guarantee shall be excluded.</p>
<p i18n="@@tac_6-5">6.5 Traders must inspect the goods immediately following delivery to ascertain any faults of quality
    or incorrect amounts and notify Hering Berlin in writing of any identifiable defects within 5 working days following
    arrival of the goods. Otherwise any claim under guarantee shall be excluded. To meet this period of grace, timely
    dispatch shall suffice. The trader shall bear the whole burden of proof that the prior conditions for a claim exist,
    particularly proof of the defect itself, proof of its presence at the time of transfer of risk, proof of the time
    when the defect was ascertained, and proof that complaint thereof was made in good time.</p>
<p i18n="@@tac_6-6">6.6 For traders the period of guarantee shall be one year following delivery of goods.
</p>
<h2 i18n="@@tac_7-headline">7. Resale – damages</h2>
<p i18n="@@tac_7-1">7.1 Customers who are also traders must not grant any rebate on products of Stefanie Hering-Berlin
    GmbH when reselling goods to end customers, unless Stefanie Hering-Berlin GmbH has agreed in advance to these
    rebates.
</p>
<p i18n="@@tac_7-2">7.2 Customers who are also traders shall have a duty in case of resale to other traders to bind the
    latter contractually in accordance with Section 7.1 of these General Terms &amp; Conditions of Business, unless
    Stefanie
    Hering-Berlin GmbH has previously issued permission to the contrary.
</p>
<p i18n="@@tac_7-3">7.3 Insofar as Stefanie Hering-Berlin GmbH is entitled to lump-sum damages, the party liable for the
    said damages shall be entitled to prove that the loss was lower than the lump-sum damages.
</p>
<h2 i18n="@@tac_8-headline">8. Restrictions of liability</h2>
<p i18n="@@tac_8-1">8.1 Hering Berlin shall be liable in case of contractual and non-contractual claims for damages by
    the customer only in case of intention or gross negligence on its own part (by its managing directors) and in case
    of negligence by its staff and vicarious agents. Should cardinal contractual duties be breached, should it be a case
    of debtor's delay, or should performance be impossible on grounds for which Hering Berlin is culpable, however,
    Hering Berlin shall be liable also for each culpable breach of duty, including breach of duty by its staff and
    vicarious agents. Except in the case of gross negligence by Hering Berlin and grossly negligent behaviour by its
    legal representatives, staff or vicarious agents, the liability of Hering Berlin shall be restricted to such loss as
    was typically foreseeable at the time when the contract was concluded.
</p>
<p i18n="@@tac_8-2">8.2 The foregoing restrictions of liability shall not apply to loss or damage resulting from injury
    to life, limb or health, nor in the case of compulsory statutory regulations, e.g. the Product Liability Act.
</p>
<h2 i18n="@@tac_9-headline">9. Concluding provisions</h2>
<p i18n="@@tac_9-1">9.1 The law of the Federal Republic of Germany shall apply. In the case of consumers who do not
    conclude the contract for professional or commercial reasons, this choice of law shall apply only insofar as the
    protection granted is not removed by compulsory provisions in legislation of the state in which the consumer has his
    usual place of residence. The provisions of the UN law of sale and purchase shall not apply.
</p>
<p i18n="@@tac_9-2">9.2 Should the customer be a merchant, legal entity under public law or a special public asset, the
    exclusive place of jurisdiction for all disputes arising from this Contract shall be the registered office of Hering
    Berlin. The same shall apply if the customer has no general place of jurisdiction in Germany, or his domicile or
    usual place of residence is not known at the time when the claim is brought.
</p>
<p i18n="@@tac_9-3">9.3 Should any individual provisions of the contract with the customer, including these General
    Terms &amp; Conditions of Business, be or become invalid, either wholly or in part, the validity of the remaining
    provisions shall not be affected thereby.
</p>
